import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import DateRangePickerProps from './DateRangePickerProps'

import Messages from './Messages'
import Month from './Month'
import Range from './Range'

export default {
    props: DateRangePickerProps,
    mixins: [
        KendoBaseComponent, 
        Messages, 
        Month, 
        Range
    ],
   
    mounted() {
        kendo.jQuery(this.$el).kendoDateRangePicker(this.widgetOptions)

        this.$emit('kendowidgetready', this.kendoWidget())
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoDateRangePicker()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoDateRangePicker/KendoDateRangePickerMixin.js